import React, { MouseEventHandler, ReactElement } from 'react';

import { DropDownMenu, PaginatorAPI, Text, Tooltip } from '@philips-internal/oswald-ui-components';
import { ReactComponent as MenuSVG } from '@philips-internal/oswald-ui-components/resources/assets/components/menu-context.svg';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isMobile } from '@philips-internal/oswald-ui-utils';

export interface Action {
  title: string;
  onClick: MouseEventHandler;
  icon: React.ComponentType<any>;
}

class Utils {

  static getFirstPagePaginator(paginatorAPI: PaginatorAPI): void {
    if (!paginatorAPI.getPage()) {
      paginatorAPI.setPage(1);
    }
  }

  static formatCnpj(cnpj: string): string {
    if (cnpj.length < 14) {
      cnpj = cnpj.padStart(14, '0');
    }
    return ModelService.format('employee-identification-number', cnpj);
  }

  static getCurrentYear(): number {
    return new Date().getFullYear();
  }

  static getCurrentMoth(): number {
    return new Date().getMonth()+1;
  }

  static capitalizeFirst(value: string): string {
    if (value && value.length > 0) {
      return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
    }
    return value;
  }

  static renderTableText(value: string): ReactElement {
    return (<Text
      className="table-text"
      value={value}
    />);
  }

  static renderActionButtons(actions: Action[]): ReactElement {
    const clickSpaceStyle = {
      cursor: 'pointer',
    };
    const actionStyle = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
    };
    if (isMobile() && actions.length > 1) {
      return (<div>
        <DropDownMenu
          uuid={generateUUID()}
          showArrow={false}
          showChevron={false}>
          <div slot="header">
            <MenuSVG/>
          </div>
          <div slot="content">
            <div className="c-menu__mobile-actions">
              {actions.map((a, index) => {
                const { title, onClick } = a;
                const props = {
                  onClick,
                };
                return (<span key={index} {...props}>{MessageService.translate(title)}</span>);
              })}
            </div>
          </div>
        </DropDownMenu>
      </div>);
    }
    return (<div style={actionStyle}>
      {actions.map((a, index) => {
        const { title, onClick, icon } = a;
        const ActionIcon = icon;
        const props = {
          onClick,
        };
        return (<Tooltip key={index} value={title}>
          <div style={clickSpaceStyle}>
            <ActionIcon {...props}/>
          </div>
        </Tooltip>);
      })}
    </div>);
  }

}

export default Utils;
